import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'
import { getVenderWelcomeInfo } from 'utils/helpers/vender-welcome-info'

const MetaTags = ({ resolvedUrl, vender, pageType }) => {
  const titleByPageType = {
    about: `【${vender?.shortname}】公司介紹－信義居家`,
    contact: `【${vender?.shortname}】聯繫資訊－信義居家`,
  }
  const title =
    titleByPageType[pageType] ||
    `【${vender?.shortname}】公司介紹、文章、相簿、特色優惠搶先看－信義居家`
  const {
    brieflyDescribeText: description,
    typicalImage,
  } = getVenderWelcomeInfo(vender)

  const pathName = resolvedUrl?.split('?')[0]
  const path = LS_APP_DOMAIN + pathName

  const breadcrumbData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首頁',
        item: 'https://livinglife.com.tw',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '廠商列表',
        item: 'https://livinglife.com.tw/vender',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: vender?.shortname,
        item: path,
      },
    ],
  }

  return (
    <Head>
      <title>{title}</title>

      <link key="canonical" rel="canonical" href={path} />

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      {!!description && (
        <meta key="description" name="description" content={description} />
      )}

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      {!!description && (
        <meta
          key="og:description"
          property="og:description"
          content={description}
        />
      )}
      {!!typicalImage?.url && (
        <meta key="og:image" property="og:image" content={typicalImage.url} />
      )}
      <meta key="og:url" property="og:url" content={path} />

      <script
        key="breadcrumb-list-json-ld"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </Head>
  )
}

export default MetaTags
